import { CategoryMatch, SubGroup } from "../helpers/interfaces/category";
import { IMatchData } from "../helpers/interfaces/matchData";
import { ICategoryGroup } from "../helpers/interfaces/ranking";
import { apiGet } from "./Api";

export const rankCategoryService = {
    getMatch: (id: string) => apiGet<IMatchData, string>("?op=partita&id=" + id),
    getCategoryGroups: (categoryId: number) => apiGet<SubGroup[], string>("?op=listaGironi&idCategoria=" + categoryId),
    getGroup: (groupId: string, season?: string) => apiGet<ICategoryGroup, string>("?op=girone&id=" + groupId + (season ? '&stagione=' + season : '')),
    getMatchesByGroup: (groupId: string) => apiGet<any[], string>("?op=partitePerGirone&idGirone=" + groupId),
    getMatchesByDay: (date: string) => apiGet<IMatchData[], string>("?op=partitePerGiorno&giorno=" + date),
    getRank: (groupId: string) => apiGet<any, string>("?op=classificaGirone&idGirone=" + groupId),
    getCalendarList: (groupId: string, season: string, groupDay: number) => apiGet<{listaCalendari: CategoryMatch[]}, any>(
        '?op=listaCalendari&idGirone=' + groupId + '&stagione=' + season + '&giornata=' + groupDay
    ),
}